"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Carousel_1 = require("./Carousel");
exports.default = Carousel_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Carousel/index.js
// module id = 432
// module chunks = 8